import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

// Connects to data-controller="promoters"
export default class extends Controller {
  static targets = ["popup_notification_modal"];

  connect() {
    if (this.hasPopup_notification_modalTarget) {
      this.modalShow(this.popup_notification_modalTarget);
    }
  }

  disconnect() {
    if (this.hasPopup_notification_modalTarget) {
      const modal = this.popup_notification_modalTarget;
      $(modal).removeClass("is-open");
      modal.close();
    }
  }

  modalShow(modal) {
    $(modal).hide();
    modal.showModal();
    $(modal).fadeIn(300).addClass("is-open");
  }

  async modalClose(modal) {
    const duration = 300;
    await new Promise((resolve) => {
      $(modal).fadeOut(duration, () => {
        $(modal).removeClass("is-open");
        modal.close();
        resolve();
      });
    });
  }

  async nextModal() {
    await this.modalClose(this.popup_notification_modalTarget);
    this.popup_notification_modalTarget.remove();
    if (this.hasPopup_notification_modalTarget) {
      this.modalShow(this.popup_notification_modalTarget);
    }
  }
}
